var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (!_vm.async)?_c('add-content-select',{attrs:{"entity":_vm.entity,"item":_vm.item},on:{"update:entity":function($event){_vm.entity=$event}}}):_c('spinner')
}
var staticRenderFns = []

export { render, staticRenderFns }